/**
 * 1-2p 纳品素材：文件在 static/home/1-2p/ 下，按首页展示顺序列出文件名。
 */
import { staticHome1_2pFile } from '@/utils/staticUrl';

export const HOME_1_2P_FILES = [
	'p1_Envi01.jpg',
	'p1_Nonte02.jpg',
	'p1_Nonte01揹夝摵.jpg',
	'p1_僄儗僋僩儘僯僢僋.jpg',
	'DOWA依_0130.jpg',
	'DOWA儊僞僯僋僗-0130.jpg',
	'摨榓嬥懏嵽椏丂忋奀-0130.jpg',
	'摨榓婇嬈娗棟忋奀-0130-2.jpg',
	'僔儞僈億乕儖-0130.jpg',
	'僴僀僥僢僋-0130.jpg',
	'朙塰彜帠.jpg',
	'摨榓棙惛枾晹昳_CMYK.jpg',
	'怴擔杮僽儔僗-0130.jpg',
	'DOWA伟倜蕤莞藿-0130.jpg',
	'摨榓婇嬈娗棟乮峀搶乯-0130.jpg',
];

export function home1_2pUrls() {
	return HOME_1_2P_FILES.map((name) => staticHome1_2pFile(name));
}



// WEBPACK FOOTER //
// ./src/config/home1-2pManifest.js